async function updateSubtotalPrices() {

  let subtotalNode = document.querySelector(
    ".rebuy-cart__flyout-subtotal-final-amount"
  );
  if(!subtotalNode) {
    subtotalNode = document.querySelector(
    ".rebuy-cart__flyout-subtotal-amount"
    );
  }
  let compareNode = document.querySelector(
    ".rebuy-cart__flyout-subtotal-compare-amount"
  );
  let totalNode;

  if (isCartPage) {
    subtotalNode = document.getElementById("cart-page-subtotal");
    totalNode = document.getElementById("cart-page-total");
  }

  const safeShipToggle = document.getElementById("safe-ship-input");
  const mysteryItemToggle = document.getElementById("mystery-item-input");

  if (!safeShipToggle || !mysteryItemToggle) return;

  console.log('updateSubtotalPrices');
  let safeShipTotalPrice = 0;
  let mysteryItemTotalPrice = parseInt(mysteryItemPrice) || 5000;
  let safeShipAddonCAP = 0;
  let mysteryItemAddonCAP = parseInt(mysteryItemCAP) || mysteryItemTotalPrice;

  let data;
  if (window.Rebuy && window.Rebuy.Cart) {
    data = Rebuy.Cart.cart;
  } else {
    data = await fetchCart();
  }

  let { items_subtotal_price, original_total_price, currency, items } = data;

  // Check if Safe Ship or Mystery Item is in the cart
  const safeShipItem = items.find((item) => item.handle === safeShipHandle);
  const mysteryItem = items.find((item) => item.handle === mysteryItemHandle);

  let adjustedSubtotal = items_subtotal_price;
  let adjustedComparePrice = items.reduce((total, item) => {
    let comparePrice =
      item.properties &&
      item.properties["_compare_at_price"] &&
      item.properties["_compare_at_price"] != "0"
        ? parseInt(item.properties["_compare_at_price"], 10)
        : item.original_price;

    return total + comparePrice * item.quantity;
  }, 0);

  if (safeShipToggle.checked) {
    // Add Safe Ship price only if it's NOT in cart already
    if (!safeShipItem) {
      adjustedSubtotal += safeShipTotalPrice;
      adjustedComparePrice += safeShipAddonCAP;
    }
  } else {
    // Subtract Safe Ship price if it's in the cart
    if (safeShipItem) {
      adjustedSubtotal -= safeShipTotalPrice;
      adjustedComparePrice -= safeShipAddonCAP;
    }
  }

  if (mysteryItemToggle.checked) {
    // Add Mystery Item price only if it's NOT in cart already
    if (!mysteryItem) {
      adjustedSubtotal += mysteryItemTotalPrice;
      adjustedComparePrice += mysteryItemAddonCAP;
    }
  } else {
    // Subtract Mystery Item price if it's in the cart
    if (mysteryItem) {
      adjustedSubtotal -= mysteryItemTotalPrice;
      adjustedComparePrice -= mysteryItemAddonCAP;
    }
  }

  if (subtotalNode) subtotalNode.innerHTML = formatMoney(adjustedSubtotal);
  if (compareNode) compareNode.innerHTML = formatMoney(adjustedComparePrice);
  if (totalNode) totalNode.innerHTML = formatMoney(adjustedSubtotal);
}

async function initializeItem({
  checkboxId,
  cookieName,
  itemHandle,
  atcData,
  priceId,
  itemPrice,
}) {
  const checkbox = document.getElementById(checkboxId);
  const priceNode = document.getElementById(priceId);
  // If cookies are not set the default value is "no"
  const itemInCartCookie = getCookieValue(cookieName) || "no";

  // Helper to update cookie and checkbox state
  const updateItemState = (state) => {
    writeCookie(cookieName, state, 10);
    if (checkbox) checkbox.checked = state === "yes";
  };

  // Initialize checkbox state and item price
  if (priceNode) priceNode.innerHTML = formatMoney(itemPrice);
  updateItemState(itemInCartCookie);

  // Add event listener to the checkbox
  if (checkbox) {
    checkbox.addEventListener("change", async () => {
      const newState = checkbox.checked ? "yes" : "no";
      updateItemState(newState);
      updateSubtotalPrices();
    });
  }
}

function redirectToCheckoutPage() {
  const rebuyCheckoutBtn = document.querySelector(
    "[data-rebuy-checkout-button]"
  );
  const cartPageCheckoutBtn = document.querySelector(
    "[data-cart-page-checkout-button]"
  );

  try {
    if (rebuyCheckoutBtn) {
      rebuyCheckoutBtn.addEventListener("click", async (event) => {
        event.preventDefault();
        await handleCheckout(rebuyCheckoutBtn);
      });
    }

    if (cartPageCheckoutBtn) {
      cartPageCheckoutBtn.addEventListener("click", async (event) => {
        event.preventDefault();
        await handleCheckout(cartPageCheckoutBtn);
      });
    }
  } catch (error) {
    console.log("Error in redirectToCheckoutPage", error);
  }
}

async function handleCheckout(button) {
  button.classList.add("checkout-btn-loading");
  button.innerHTML = `
      <span class="checkout-btn-loader"></span>
      <span>Checking Out</span>
  `;

  let attempts = 0;
  let success = false;

  while (attempts < 4) {
    success = await checkAndSyncAddonsState();
    if (success) break;

    console.log(`Attempt ${attempts + 1} failed. Retrying...`);
    await delay(1200); // Wait 1 second before retrying
    attempts++;
  }

  window.location.href = "/checkout";

  // if (success) {
  //   window.location.href = "/checkout";
  // } else {
  //   button.classList.remove("checkout-btn-loading");
  //   button.innerHTML = "Checkout";
  //   console.error("Cart did not update correctly after multiple attempts.");
  // }
}

async function checkAndSyncAddonsState() {
 // const safeShipToggle = document.getElementById("safe-ship-input");
  const mysteryItemToggle = document.getElementById("mystery-item-input");

  try {
    let data = await fetchCart();
    let { items } = data;

    // const safeShipItemInCart = items.find(
    //   (item) => item.handle === safeShipHandle
    // );
    const mysteryItemInCart = items.find(
      (item) => item.handle === mysteryItemHandle
    );

    const updates = {};
    const itemsToAdd = [];

    // if (safeShipToggle.checked && !safeShipItemInCart) {
    //   itemsToAdd.push(safeShipAtcData);
    // } else if (!safeShipToggle.checked && safeShipItemInCart) {
    //   updates[safeShipItemInCart.key] = 0;
    // }

    if (mysteryItemToggle.checked && !mysteryItemInCart) {
      itemsToAdd.push(mysteryAtcData);
    } else if (!mysteryItemToggle.checked && mysteryItemInCart) {
      updates[mysteryItemInCart.key] = 0;
    }

    if (itemsToAdd.length > 0) {
      if (window.Rebuy && window.Rebuy.SmartCart)
        Rebuy.SmartCart.skip_open = true;
      await fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: itemsToAdd }),
      });
    }

    if (Object.keys(updates).length > 0) {
      if (window.Rebuy && window.Rebuy.SmartCart)
        Rebuy.SmartCart.skip_open = true;
      await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ updates }),
      });
    }

    await delay(500);
    return await verifyCartState();
  } catch (error) {
    console.error("Error in checkAndSyncAddonsState:", error);
    return false;
  }
}

async function verifyCartState() {
  //const safeShipToggle = document.getElementById("safe-ship-input");
  const mysteryItemToggle = document.getElementById("mystery-item-input");

  let data = await fetchCart();
  let { items } = data;

  // const safeShipItemInCart = items.find(
  //   (item) => item.handle === safeShipHandle
  // );
  const mysteryItemInCart = items.find(
    (item) => item.handle === mysteryItemHandle
  );

  return (
    mysteryItemToggle.checked === !!mysteryItemInCart
  );
}

function delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

function removeAED() {
  console.log("Formatting prices to AED");

  const formatCurrency = (el) => {
    if (el && el.textContent) {
      let text = el.textContent;

      // Replace "Dhs." or "Dhs. " with "AED"
      text = text.replace(/Dhs\.?\s*/g, 'AED ');

      // Remove trailing "AED" (with optional space)
      text = text.replace(/\s*AED\s*$/, '');

      // Ensure it starts with "AED"
      if (!text.startsWith('AED')) {
        text = 'AED ' + text;
      }

      el.textContent = text.trim();
    }
  };

  // Update all .rebuy-money price spans
  document.querySelectorAll('.rebuy-money > span:not(.sr-only)').forEach(formatCurrency);

  // Update other specific subtotal elements
  const selectors = [
    // '.rebuy-cart__flyout-subtotal-final-amount > span:not(.sr-only)',
    // '.rebuy-cart__flyout-subtotal-compare-amount > span:not(.sr-only)',
    // '.rebuy-cart__flyout-subtotal-amount',
  ];

  selectors.forEach(selector => {
    const el = document.querySelector(selector);
    formatCurrency(el);
  });
}

document.addEventListener("rebuy:cart.change", function (event) {
  setTimeout(() => {
    updateSubtotalPrices();
  }, 1000);
});

document.addEventListener("rebuy:smartcart.show", (event) => {
  //console.log('show smart cart event');
  setTimeout(() => {
    removeAED();
    updateSubtotalPrices();
    redirectToCheckoutPage();

    initializeItem({
      checkboxId: "mystery-item-input",
      cookieName: "mystery-item-in-cart",
      itemHandle: mysteryItemHandle,
      atcData: mysteryAtcData,
      priceId: "mystery-item-price",
      itemPrice: mysteryItemPrice,
    });
  }, 500);
});

if (isCartPage) {
  redirectToCheckoutPage();
  updateSubtotalPrices();

  initializeItem({
    checkboxId: "mystery-item-input",
    cookieName: "mystery-item-in-cart",
    itemHandle: mysteryItemHandle,
    atcData: mysteryAtcData,
    priceId: "mystery-item-price",
    itemPrice: mysteryItemPrice,
  });
} else {
  document.addEventListener("rebuy:cart.ready", async () => {
    setTimeout(() => {
      redirectToCheckoutPage();

      initializeItem({
        checkboxId: "mystery-item-input",
        cookieName: "mystery-item-in-cart",
        itemHandle: mysteryItemHandle,
        atcData: mysteryAtcData,
        priceId: "mystery-item-price",
        itemPrice: mysteryItemPrice,
      });
      updateSubtotalPrices();
    }, 1500);
  });
}
